import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=7730745b&"
import script from "./CardSkeleton.vue?vue&type=script&lang=js&"
export * from "./CardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QItem,QItemSection,QSkeleton,QItemLabel,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QItem,QItemSection,QSkeleton,QItemLabel,QSeparator,QCardActions})
